module.exports = __webpack_public_path__ + "static/media/HandIcon.99976c79.svg";